import { ref, push, set, onValue, query, orderByChild, limitToLast } from 'firebase/database'
import { db, tref } from './firebase.js'

// Suite-wide activity feed. Every module appends an event here; the dashboard
// Recent Activity reads the tail. Fire-and-forget: never blocks the caller.
//   {id}: { type, memberId?, text, icon, timestamp }
const BASE = 'club/activity'

export function logActivity({ type, memberId = null, text, icon = '•' }) {
  try {
    const node = push(tref(BASE))
    return set(node, { type: type || 'event', memberId, text: String(text || ''), icon, timestamp: Date.now() })
  } catch { return Promise.resolve() }
}

export function watchActivity(cb, max = 40) {
  const q = query(tref(BASE), orderByChild('timestamp'), limitToLast(max))
  return onValue(q, (snap) => {
    const rows = Object.entries(snap.val() || {}).map(([id, v]) => ({ id, ...v }))
    rows.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0))
    cb(rows)
  })
}
